import { useEffect, useState } from "react";
import { useSiteContent } from "../content.js";
import { ABOUT_THE_DATA_TEXT } from "./stats.jsx";

export default function Footer() {
  const { footer: copy } = useSiteContent();
  const [dataModalOpen, setDataModalOpen] = useState(false);
  return (
    <footer className="footer">
      <div className="section-inner footer-inner">
        <div className="footer-row">
          <div>
            <div className="footer-brand">
              <span className="footer-mark">GP</span>
              <div>
                <div className="display h-sm" style={{ margin: 0 }}>
                  {copy.brand}
                </div>
                <div
                  className="mono"
                  style={{
                    fontSize: "0.6875rem",
                    color: "var(--royal-blue-glow)",
                    letterSpacing: "0.16em",
                    marginTop: 4,
                  }}
                >
                  {copy.subbrand}
                </div>
              </div>
            </div>
            <p className="footer-copy">{copy.quote}</p>
          </div>
          <div className="footer-cols">
            <div>
              <div className="mono footer-h">SITE</div>
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("hero")?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Home
              </a>
              <a href="/live">Greg's Live Booth</a>
              <a
                href="#book"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("book")?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                The Book
              </a>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("about")?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                About Greg
              </a>
              <a href="/stats">Career Stats</a>
              <a
                href="#memorabilia"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("memorabilia")?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                The Collection
              </a>
              <a href="/ama">The Reddit AMA</a>
              <a
                href="#speaking"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("speaking")?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                On the Road
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Get in Touch
              </a>
            </div>
            <div>
              <div className="mono footer-h">ELSEWHERE</div>
              <a href="mailto:gpryor@lifepriority.com">Email Greg</a>
              <a
                href="https://www.facebook.com/GregPryor85/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
              <a
                href="https://www.amazon.com/Day-Yankees-Made-Me-Shave-ebook/dp/B08FV8TLGW"
                target="_blank"
                rel="noopener noreferrer"
              >
                Amazon
              </a>
              <a href="https://lifepriority.com" target="_blank" rel="noopener noreferrer">
                Life Priority
              </a>
            </div>
            <div>
              <div className="mono footer-h">LEGAL</div>
              <a href="/privacy">Privacy Policy</a>
              <a
                href="#about-the-data"
                onClick={(e) => {
                  e.preventDefault();
                  setDataModalOpen(true);
                }}
              >
                About the data
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <span className="mono">{copy.copyright}</span>
          <span className="mono">{copy.credit}</span>
        </div>
      </div>
      {dataModalOpen && <AboutDataModal onClose={() => setDataModalOpen(false)} />}
    </footer>
  );
}

function AboutDataModal({ onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  return (
    <div
      className="data-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="data-modal-title"
    >
      <div className="data-modal" onClick={(e) => e.stopPropagation()}>
        <div className="data-modal-head">
          <div>
            <div className="mono data-modal-kicker">About the data</div>
            <h3 id="data-modal-title" className="display data-modal-title">
              Where these numbers come from.
            </h3>
          </div>
          <button className="data-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="data-modal-body">{ABOUT_THE_DATA_TEXT}</div>
      </div>
    </div>
  );
}

const footerStyles = document.createElement("style");
footerStyles.textContent = `
.footer {
  background: #030810;
  border-top: 1px solid var(--rule);
  padding: 80px 0 40px;
}
.footer-row {
  display: grid;
  grid-template-columns: 1.4fr 2fr;
  gap: 56px;
  padding-bottom: 56px;
  border-bottom: 1px solid var(--rule);
}
@media (max-width: 768px) { .footer-row { grid-template-columns: 1fr; gap: 32px; } }
.footer-brand { display: flex; align-items: center; gap: 14px; margin-bottom: 24px; }
.footer-mark {
  width: 48px; height: 48px;
  border: 1px solid var(--royal-blue-bright);
  background: var(--royal-blue);
  color: var(--bone);
  display: grid; place-items: center;
  font-family: var(--mono);
  font-size: 0.875rem; font-weight: 600;
  border-radius: 50%;
}
.footer-copy {
  font-family: var(--serif);
  font-style: italic;
  font-size: 1rem;
  color: var(--bone-dim);
  max-width: 44ch;
  margin: 0;
  line-height: 1.5;
}
.footer-cols {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
@media (max-width: 540px) { .footer-cols { grid-template-columns: 1fr 1fr; } }
.footer-cols a {
  display: block;
  padding: 6px 0;
  color: var(--bone-dim);
  font-size: 0.875rem;
  transition: color 200ms;
}
.footer-cols a:hover { color: var(--gold); }
.footer-h { font-size: 0.625rem; color: var(--gold); letter-spacing: 0.18em; margin-bottom: 12px; }
.footer-bottom {
  margin-top: 32px;
  display: flex; justify-content: space-between;
  font-size: 0.625rem; letter-spacing: 0.16em; color: var(--bone-dim);
  flex-wrap: wrap; gap: 12px;
}

/* About-the-data lightbox */
.data-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(3, 8, 16, 0.78);
  backdrop-filter: blur(6px);
  animation: data-modal-fade 180ms ease-out;
}
@keyframes data-modal-fade { from { opacity: 0; } to { opacity: 1; } }
.data-modal {
  width: 100%;
  max-width: 600px;
  max-height: calc(100vh - 48px);
  overflow: auto;
  background: var(--navy-800);
  border: 1px solid var(--rule);
  box-shadow: 0 44px 90px -34px rgba(0, 0, 0, 0.7);
  animation: data-modal-rise 220ms cubic-bezier(0.2, 0.8, 0.2, 1);
}
@keyframes data-modal-rise {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}
.data-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 26px 28px 18px;
  border-bottom: 1px solid var(--rule);
}
.data-modal-kicker {
  color: var(--gold);
  font-size: 0.625rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.data-modal-title {
  margin: 0;
  font-size: 1.625rem;
  line-height: 1.15;
  color: var(--bone);
}
.data-modal-close {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: 1px solid var(--rule);
  border-radius: 50%;
  background: transparent;
  color: var(--bone-dim);
  font-size: 1.375rem;
  line-height: 1;
  cursor: pointer;
  transition: color 200ms, border-color 200ms, background 200ms;
}
.data-modal-close:hover {
  color: var(--bone);
  border-color: var(--gold);
  background: rgba(189, 155, 96, 0.08);
}
.data-modal-body {
  padding: 22px 28px 28px;
}
.data-modal-body p {
  margin: 0;
  color: var(--bone-dim);
  font-family: var(--serif);
  font-size: 1rem;
  line-height: 1.6;
}
.data-modal-body a {
  color: var(--gold);
  text-decoration: underline;
  text-underline-offset: 3px;
}
.data-modal-body a:hover { color: var(--gold-bright); }
@media (max-width: 540px) {
  .data-modal-head { padding: 20px 20px 14px; }
  .data-modal-body { padding: 16px 20px 22px; }
  .data-modal-title { font-size: 1.375rem; }
}
`;
document.head.appendChild(footerStyles);
